export const setupRequestFrontendPath = '/e_payment/setup_request/';
export const setupRequestBackendPath = '/backend/epayment/shop_setting/list/';

export const setupRequestEditFrontendPath = '/e_payment/setup_request/edit';
export const setupRequestEditBackendPath = '/backend/epayment/shop_setting/update/';

export const getServiceTerminalIdBackendPath = '/backend/epayment/shop_setting/service/get/';



// WEBPACK FOOTER //
// ./src/routes/e_payment/urls.js